import React from "react";
import { Flex } from "@chakra-ui/react";
import { BiInfinite } from "react-icons/bi";

const GaraazInfinityIcon: React.FC = () => {
  return (
    <Flex justifyContent="center" alignItems="center">
      <BiInfinite />
    </Flex>
  );
};

export default GaraazInfinityIcon;
